/**
 * @author: liaojianming
 * @date 2019-02-18
 * @description: mixin.js
 */

// 工具类
import Helper from '@/util/helper'
import Enum from '@/util/enum'
import Author from '@/util/author'
import Notification from '@/util/notification'
import { mapState } from 'vuex'
import storage from '@/util/localstorage'
import Sessionstorage from '@/util/sessionstorage'
import store from '@/store/index'

// 接口
import { QueryDepartmentTreeNode } from '@/api/systemPrivilege/organization'
import { QuerySystemMenuNodeList } from '@/api/systemPrivilege/menu'

// 分页请求Mixin
export const paginationMixin = {
  data() {
    return {
      defaultPageNum: 1,
      defaultPageSize: 10,
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      layout: 'total, sizes, prev, pager, next, jumper',
      pageSizes: [10, 15, 30, 45, 60],
      tableOption: {
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
        loadingStatus: true,
        stripe: true
      }
    }
  },
  methods: {
    // 分页请求
    handleCurrentChange(val) {
      this.currentPage = val
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.toggleLoadingStatus()
      this.searchData(params)
    },
    // 切换每页显示多少条数据
    handleSizeChange(val) {
      this.pageSize = val
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.toggleLoadingStatus()
      this.searchData(params)
    },
    toggleLoadingStatus() {
      this.tableOption.loadingStatus = !this.tableOption.loadingStatus
    }
  }
}

// 组织架构
export const organizationMixin = {
  data() {
    return {
      departmentList: new Array()
    }
  },
  created() {
    this.renderOrganizationNodeTree()
  },
  methods: {
    // 初始化组织架构
    renderOrganizationNodeTree() {
      QueryDepartmentTreeNode({ systemDeptId: '' }).then(res => {
        if (!res) return
        if (res.success && res.data.root.hasOwnProperty('children')) {
          var departmentList = this.resoveDepartmentNodeList(
              res.data.root.children
            ),
            array = new Array()
          array.push({
            children: departmentList,
            id: res.data.root.systemDeptId,
            parentId: res.data.root.parentId,
            available: res.data.root.available === 1 ? '启用' : '禁用',
            updateDate: Helper.time(res.data.root.updateDate),
            serverConfigId: res.data.root.serverConfigId,
            label: res.data.root.deptName,
            deptType: res.data.root.deptType,
            sortNum: res.data.root.sortNum,
            source: res.data.root.source
          })
          this.departmentList = array
        }
      })
    },
    // 数据封装
    resoveDepartmentNodeList(departmentNodeList) {
      let departmentListArray = new Array()
      ;(departmentNodeList || []).forEach((departNode, index) => {
        if (
          departNode.hasOwnProperty('children') &&
          Array.isArray(departNode.children)
        ) {
          departmentListArray.push({
            id: departNode.systemDeptId,
            parentId: departNode.parentId,
            label: departNode.deptName,
            deptType: departNode.deptType,
            available: departNode.available === 1 ? '启用' : '禁用',
            updateDate: Helper.time(departNode.updateDate),
            serverConfigId: departNode.serverConfigId,
            sortNum: departNode.sortNum,
            source: departNode.source,
            // 递归调用
            children: this.resoveDepartmentNodeList(departNode.children)
          })
        }
      })
      return departmentListArray
    }
  }
}

// 菜单
export const menuManageMixin = {
  data() {
    return {
      roleMenuNodeList: new Array(),
      roleMenuNodeListE: new Array()
    }
  },
  created() {
    this.renderMenuNodeList()
  },
  computed: {
    serverConfig(val) {
      let matchArray =  this.$store.state.d2admin.menu.serverConfigList.filter(item => {
        return item.value === val
      })
      return matchArray.length ? matchArray[0].label : ''
    }
  },
  methods: {
    // 获取所有菜单
    renderMenuNodeList() {
      QuerySystemMenuNodeList({ systemMenuPermissionId: '' }).then(res => {
        if (!res) return
        var roleMenuNodeList = this.resoveMenuNodeList(res.data.root.children),
          array = new Array()
        array.push({
          children: roleMenuNodeList,
          id: res.data.root.systemMenuPermissionId,
          parentId: res.data.root.parentId,
          label: res.data.root.menuName,
          menuType: res.data.root.treeNodeType,
          available: res.data.root.available === 1 ? '启用' : '禁用',
          serverConfigId: res.data.root.serverConfigId,
          serverConfigName: this.getServerConfig(res.data.root.serverConfigId),
          updateDate: Helper.time(res.data.root.updateDate),
          menuTypeCode: res.data.root.menuTypeCode,
          menuTypeCodeName: Enum.systemPermission.menuManage.menuType.getValue(res.data.root.menuTypeCode),
          sortNum: res.data.root.sortNum
        })
        this.roleMenuNodeList = array
        this.roleMenuNodeListE = this.roleMenuNodeList
      })
    },
    // 数据封装
    resoveMenuNodeList(menuNodeList) {
      let menuListArray = new Array()
      ;(menuNodeList || []).forEach((menuNode, index) => {
        if (
          menuNode.hasOwnProperty('children') &&
          Array.isArray(menuNode.children)
        ) {
          menuListArray.push({
            id: menuNode.systemMenuPermissionId,
            parentId: menuNode.parentId,
            label: menuNode.menuName,
            menuType: menuNode.treeNodeType,
            available: menuNode.available === 1 ? '启用' : '禁用',
            updateDate: Helper.time(menuNode.updateDate),
            serverConfigId: menuNode.serverConfigId,
            serverConfigName: this.getServerConfig(menuNode.serverConfigId),
            menuTypeCode: menuNode.menuTypeCode,
            menuTypeCodeName: Enum.systemPermission.menuManage.menuType.getValue(menuNode.menuTypeCode),
            sortNum: menuNode.sortNum,
            // 递归调用
            children: this.resoveMenuNodeList(menuNode.children)
          })
        }
      })
      return menuListArray
    },
    // 获取服务配置凝成
    getServerConfig(val) {
      let matchArray =  this.$store.state.d2admin.menu.serverConfigList.filter(item => {
        return item.value === val
      })
      return matchArray.length ? matchArray[0].label : ''
    }
  }
}

export const filtersMixin = {
  filters: {
    generateTimestamp_YYYYMMDDHHMMSS() {
      return Helper.time()
    },
    //流程分组
    getProcessGroupText(value) {
      return Enum.common.processGroup.getValue(value)
    },
    //流程状态
    getProcessAbleStatusText(value) {
      return Enum.common.processAbleStatus.getValue(value)
    },
    //分公司
    getSubCompanyText(value) {
      return Enum.common.subCompany.getValue(value)
    }
  }
}

export const filterUserMixin = {
  data() {
    return {
      filterText: ''
    }
  },
  methods: {
    // 节点搜索过滤
    filterNode(value, data) {
      if (!value) return true
      if (!data.label) return true
      return data.label.indexOf(value) !== -1
    }
  },
  watch: {
    filterText(val) {
      this.$refs.filterUserMenuTree && this.$refs.filterUserMenuTree.filter(val)
    }
  }
}





// 初始化用户菜单
export const initAuthorMenuMixin = {
  methods: {
    async renderCurrentAuthorMenu(serverName) {
      // 调取 查询菜单接口
      await store.dispatch('getSystemUser')
    },
    
    async getMenuList (key = 'menuList') {
      let systemUser = await store.dispatch('getSystemUser');
      let menuList = systemUser.systemMenuPermissionsRoot.hasOwnProperty('children') ? systemUser.systemMenuPermissionsRoot.children : ''
      let systemRoles = systemUser.systemRoles || []

      Sessionstorage.setMenuRootlist(menuList)
      Sessionstorage.setSystemRolest(systemRoles)
      return Promise.resolve({menuList, systemRoles}[key])
    }
  }  
}
